import config from "../../../configs/config";
import { DEFAULT_MAP_CENTER } from "./constants";
const LS_KEY = '[ref-client] Map Center';

export function setDefaultMapCenter(coords) {
  localStorage.setItem(LS_KEY, coords);
}
// Get the currrent user location using the Geolocation API
export function getUserLocation() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation not supported'));
      return;
    }
    
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const coords = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        resolve(coords);
      },
      (error) => {
        console.warn('Geolocation error:', error.message);
        reject(error);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,         
        maximumAge: 300000      
      }
    );
  });
}

export function getDefaultMapCenter() {
  const coords = localStorage.getItem(LS_KEY);
  if (coords) {
    const [lat, lng] = coords.split(',').map(Number);
    return { lat, lng };
  }
  return null;
}

// set the user position to current location either from the already stored location or from the geolocation API
export async function getMapCenter() {
  try {
    const storedLocation = localStorage.getItem(LS_KEY);
    let coords;
    
    if(storedLocation){
      const [lat, lng] = storedLocation.split(',').map(Number);
      coords = { lat, lng };
    }
    else{
      try{
        coords = await getUserLocation();
      }
      catch(error){
        console.warn('Could not get user location:', error.message);
        coords = config.defaultCenter || DEFAULT_MAP_CENTER;
      }
    }

    setDefaultMapCenter(`${coords.lat},${coords.lng}`);
    return coords;

  } catch (error) {
    console.warn('Could not get user location:', error.message);
    throw error; 
  }
}
